import { Switch, Route } from 'react-router-dom';
import CostPerChild from './costPerChild';
import ReportPowerBi from './powerbi';

const Reports = () => {
  return (
    <Switch>
      <Route exact path='/reports' component={ReportPowerBi} />
      <Route exact path='/reports/powerbi' component={ReportPowerBi} />
      <Route exact path='/reports/costperchild' component={CostPerChild} />
    </Switch>
  );
};

export default Reports;
